import React from 'react';
import './colors.css';

const Menu = ({ setActiveTab, setMenuOpen, handleLogout }) => {
  return (
    <div style={{ position: "absolute", top: 0, left: 0, width: "250px", height: "100%", backgroundColor: "var(--menu-item-background-color)", color: "var(--text-color)", zIndex: 999, padding: "20px", boxShadow: "2px 0 5px rgba(0,0,0,0.5)", fontFamily: "'Press Start 2P', sans-serif" }}>
      <ul style={{ listStyleType: "none", padding: 0 }}>
        <li style={{ marginBottom: "10px" }}>
          <button onClick={() => { setActiveTab("Profile"); setMenuOpen(false); }} style={{ padding: "10px 20px", fontSize: "16px", width: "100%", background: "var(--menu-item-background-color)", border: "none", color: "var(--text-color)", borderRadius: "5px", cursor: "pointer", transition: "background 0.3s", fontFamily: "'Press Start 2P', sans-serif" }}>
            Profile
          </button>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <button onClick={() => { handleLogout(); setMenuOpen(false); }} style={{ padding: "10px 20px", fontSize: "16px", width: "100%", background: "var(--menu-item-background-color)", border: "none", color: "var(--text-color)", borderRadius: "5px", cursor: "pointer", transition: "background 0.3s", fontFamily: "'Press Start 2P', sans-serif" }}>
            Logout
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Menu;